import type React from 'react';
import classes from './protected-layout.module.scss';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useShiftAuth } from '../../contexts/ShiftAuthProvider';
import { WorkSchedulePage } from '../../pages/WorkSchedulePage';
import { VacationsPage } from '../../pages/VacationsPage';
import { ReportsPage } from '../../pages/ReportsPage';
import { AttendancePage } from '../../pages/AttendancePage';
import { CostsPage } from '../../pages/CostsPage';
import { ManagerReportsPage } from '../../pages/ManagerReportsPage';
import { ShiftHeader } from '../../components/ShiftHeader';
import { HomePage } from '../../pages/HomePage';
import { AvailabilityPage } from '../../pages/AvailabilityPage';
import { EmployeesPage } from '../../pages/EmployeesPage';
import { ProfilePage } from '../../pages/ProfilePage';
import { ChangePasswordPage } from '../../pages/ChangePasswordPage';
import { StaffingDemandPage } from '../../pages/StaffingDemandPage';
import { EmployeeSchedulingPage } from '../../pages/EmployeeSchedulingPage';
import { NotificationsPage } from '../../pages/NotificationsPage/NotificationsPage';

export const ProtectedLayout: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useShiftAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <main className="page">
        <section className="card">Loading...</section>
      </main>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <main className={classes.appShell}>
      <ShiftHeader />
      <div className={classes.contentWrap}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/availability" element={<AvailabilityPage />} />
          <Route path="/employees" element={<EmployeesPage />} />
          <Route path="/schedule" element={<WorkSchedulePage />} />
          <Route path="/vacations" element={<VacationsPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route
            path="/reports"
            element={user?.role === 'manager' ? <ManagerReportsPage /> : <ReportsPage />}
          />
          <Route path="/attendance" element={<AttendancePage />} />
          <Route path="/costs" element={user?.role === 'manager' ? <CostsPage /> : <Navigate to="/" replace />} />
          <Route path="/staffing-demand" element={user?.role === 'manager' ? <StaffingDemandPage /> : <Navigate to="/" replace />} />
          <Route path="/employee-scheduling" element={user?.role === 'manager' ? <EmployeeSchedulingPage /> : <Navigate to="/" replace />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </main>
  );
};
